import React from 'react';

const Dashboard = () => {
    return (
        <div className='bg-base-200 min-h-screen mt-10 rounded-xl'>
            <h2 className='text-3xl font-bold text-center my-10'>Welcome to DashBoard</h2>
        </div>
    );
};

export default Dashboard;